import { ViewCountKeyEnum } from '@ztechapps/common.contract'
import { useViewCount, type UseViewCountResult } from '@ztechapps/common.hook'

/**
 * Hook for managing Logistic view counts.
 * Automatically increments the view count when the logistic is viewed.
 *
 * @param logisticId - The ID of the logistic
 * @returns viewCount, increment, loading, error
 *
 * @example
 * const { viewCount } = useLogisticViewCount(logisticId)
 */
export function useLogisticViewCount(logisticId: string): UseViewCountResult {
  return useViewCount({
    key: ViewCountKeyEnum.Logistic,
    value: logisticId,
  })
}
